/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_SaveInputs */

const th_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`บันทึก`)
};

const en_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save`)
};

const ja_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存`)
};

const zh_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`保存`)
};

const es_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar`)
};

const pt_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salvar`)
};

const id_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan`)
};

const fr_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer`)
};

const tl_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I-save`)
};

const vi_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lưu`)
};

const ko_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저장`)
};

const de_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speichern`)
};

const ru_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сохранить`)
};

const tr_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kaydet`)
};

const it_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salva`)
};

const pl_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zapisz`)
};

const uk_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Зберегти`)
};

const hi_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सहेजें`)
};

const ar_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`حفظ`)
};

const ms_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simpan`)
};

const bn_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সংরক্ষণ`)
};

const zh_tw2_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儲存`)
};

const zh_hk2_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`儲存`)
};

const ur_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محفوظ کریں`)
};

const fa_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذخیره`)
};

const sw_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hifadhi`)
};

const nl_org_save = /** @type {(inputs: Org_SaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Opslaan`)
};

/**
* | output |
* | --- |
* | "Save" |
*
* @param {Org_SaveInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_save = /** @type {((inputs?: Org_SaveInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_SaveInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_save(inputs)
	if (locale === "ja") return ja_org_save(inputs)
	if (locale === "zh") return zh_org_save(inputs)
	if (locale === "es") return es_org_save(inputs)
	if (locale === "pt") return pt_org_save(inputs)
	if (locale === "id") return id_org_save(inputs)
	if (locale === "fr") return fr_org_save(inputs)
	if (locale === "tl") return tl_org_save(inputs)
	if (locale === "vi") return vi_org_save(inputs)
	if (locale === "ko") return ko_org_save(inputs)
	if (locale === "de") return de_org_save(inputs)
	if (locale === "ru") return ru_org_save(inputs)
	if (locale === "tr") return tr_org_save(inputs)
	if (locale === "it") return it_org_save(inputs)
	if (locale === "pl") return pl_org_save(inputs)
	if (locale === "uk") return uk_org_save(inputs)
	if (locale === "hi") return hi_org_save(inputs)
	if (locale === "ar") return ar_org_save(inputs)
	if (locale === "ms") return ms_org_save(inputs)
	if (locale === "bn") return bn_org_save(inputs)
	if (locale === "zh-TW") return zh_tw2_org_save(inputs)
	if (locale === "zh-HK") return zh_hk2_org_save(inputs)
	if (locale === "ur") return ur_org_save(inputs)
	if (locale === "fa") return fa_org_save(inputs)
	if (locale === "sw") return sw_org_save(inputs)
	if (locale === "nl") return nl_org_save(inputs)
	return en_org_save(inputs)
});